import BaseService from "@client.services/baseService";

export default class TeamService extends BaseService {
  constructor() {
    super("team", true);
  }

  async getAll() {
    return super.api("");
  }
}
